var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.942383C5.60755 0.942383 0 6.54986 0 13.4424C0 20.3349 5.60747 25.9424 12.5 25.9424C19.3925 25.9424 25 20.3349 25 13.4424C25 6.54986 19.3925 0.942383 12.5 0.942383ZM12.5 2.79407C18.3917 2.79407 23.1481 7.5506 23.1481 13.4422C23.1481 19.3338 18.3916 24.0904 12.5 24.0904C6.60838 24.0904 1.85185 19.3338 1.85185 13.4422C1.85185 7.5506 6.60838 2.79407 12.5 2.79407ZM12.5 5.57201C11.9885 5.57201 11.5742 5.98666 11.5742 6.49785V13.4423C11.5742 13.7846 11.7608 14.0778 12.0372 14.238C13.7637 15.235 15.512 16.2454 17.2456 17.2471C17.6887 17.5029 18.2632 17.3572 18.5186 16.9145C18.7743 16.4717 18.6142 15.9114 18.1714 15.6556L13.4259 12.9071V6.49782C13.4259 5.98629 13.0112 5.57198 12.5 5.57198L12.5 5.57201Z",
    fill: "#040707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaceIcon);
export default __webpack_public_path__ + "static/media/PaceIcon.223ca7477f6e1e1bfbec43b8295aed16.svg";
export { ForwardRef as ReactComponent };